import { createFileRoute } from "@tanstack/react-router";
import WhatToExpectSaintPage from "@/pages/learn/WhatToExpectSaintPage";
import { pageWhatToExpect } from "@/pages/learn/learnDataWhatToExpect";
export const Route = createFileRoute("/learn/what-to-expect-during-saint-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Happens During the 5 Days of SAINT®? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "What happens during the five days of SAINT® TMS: before treatment, Day 1, Days 2-4, Day 5, after treatment, targeting, sessions, breaks, sensations.",
        },
        {
          property: "og:title",
          content: "What Happens During the 5 Days of SAINT®? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "What happens during the five days of SAINT® TMS: before treatment, Day 1, Days 2-4, Day 5, after treatment, targeting, sessions, breaks, sensations.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/what-to-expect-during-saint-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/what-to-expect-during-saint-tms",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageWhatToExpect.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatToExpectSaintPage />;
}
